// extracted by mini-css-extract-plugin
export default {"permissionDenied":"rewardsRoute_permissionDenied__NK7e3","page":"rewardsRoute_page__phTM4","slide-in-bottom":"rewardsRoute_slide-in-bottom__RWn5o"};